import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="bg-black border-t border-zinc-800 mt-auto" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 py-8">
        <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
          <div className="text-center md:text-left space-y-1">
            <p className="text-zinc-400 text-sm">
              © 2026 PREGIATO - Tutti i diritti riservati
            </p>
            <p className="text-zinc-500 text-xs" data-testid="footer-phones">
              Tel:{" "}
              <a href="tel:+393342057548" className="hover:text-white transition-colors">334 205 7548</a>
              {" · "}
              <a href="tel:+393928612924" className="hover:text-white transition-colors">392 861 2924</a>
            </p>
          </div>
          <div className="flex space-x-6">
            <Link
              to="/programma-fedelta"
              className="text-zinc-400 hover:text-yellow-500 text-sm transition-colors"
              data-testid="loyalty-link"
            >
              Programma Fedeltà
            </Link>
            <Link
              to="/privacy-policy"
              className="text-zinc-400 hover:text-white text-sm transition-colors"
              data-testid="privacy-link"
            >
              Privacy Policy
            </Link>
            <Link
              to="/contatti"
              className="text-zinc-400 hover:text-white text-sm transition-colors"
              data-testid="contacts-link"
            >
              Contatti
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
